package one.healthium.pilates

import one.primehealth.app.BaseAppConfig
import one.primehealth.app.BaseUrls
import one.primehealth.app.FirebaseAppConfig
import one.primehealth.app.Flavour
import one.primehealth.app.PlatformValues

internal fun appConfig(flavour: Flavour) =
    BaseAppConfig(
        baseUrls = BaseUrls(
            content = when (flavour) {
                Flavour.Stage -> "https://pilates-content-stage.web.app/"
                Flavour.Prod -> "https://pilates-content-prod.web.app/"
            }
        ),
        intercomApiKey = PlatformValues(
            android = "android_sdk-376cc4ff3418a1fc242d34ef12e9c3d4ff8b9fa8",
            ios = "ios_sdk-1f273098a984821e01c616b73804fe92584b24d9",
            web = "",
        ),
        intercomAppKey = "qpjbxd63",
        intercomAppName = "PILATES",
        amplitudeKey = when (flavour) {
            Flavour.Stage -> "8ecdf6c37fd8da99bc721791b147804c"
            Flavour.Prod -> "8059604c59f899f440a09b59557848de"
        },
        adaptyKey = "public_live_wrKJBds2.upUXbu7DYKEyO6at83mq",
        appsflyerKey = "obcS6CH7xbbq3Kgqd3xXUH",
        appleAppId = "6740088449",
        feedbackEmail = "pilates@healthium.one",
        firebaseApp = when (flavour) {
            Flavour.Stage -> FirebaseAppConfig(
                applicationId = "1:846342234537:android:4d60eca65386249164a4b8",
                apiKey = "AIzaSyDQOYoHDhnSfZex-NkJJ6A--Jl8yxaoNpE",
                projectId = "pilates-app-stage",
                storageBucket = "pilates-app-stage.firebasestorage.app",
                userStorageBucket = "gs://pilates-app-stage-users-data",
                authDomain = "pilates-app-stage.firebaseapp.com",
            )

            Flavour.Prod -> FirebaseAppConfig(
                applicationId = "1:636332442902:android:8fbd376a7cec7aa454bc37",
                apiKey = "AIzaSyD2U7hFx3byqOZbYXnkTVj0LiQ41xiMkc4",
                projectId = "pilates-app-prod",
                storageBucket = "pilates-app-prod.firebasestorage.app",
                userStorageBucket = "gs://pilates-app-prod-users-data",
                authDomain = "pilates-app-prod.firebaseapp.com",
            )
        },
        appId = when (flavour) {
            Flavour.Stage -> "pilates_stage"
            Flavour.Prod -> "pilates"
        },
        oneLinkBaseUrl = "https://hltm-pilates.onelink.me/Jt4s/web",
    )

